export const ERROR_CODES = {
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  FILE_TOO_LONG: 'FILE_TOO_LONG',
  FILE_METADATA_EXTRACT_FAILED: 'FILE_METADATA_EXTRACT_FAILED',
};

export const ERROR_CODE_MAP = {
  [ERROR_CODES.FILE_TOO_LARGE]: {
    titleLocaleKey: 'File too large.',
    descriptionLocaleKey: 'video_exceeds_max_file_size',
    shortDescriptionLocaleKey: 'exceeds_size_limit',
  },
  [ERROR_CODES.FILE_TOO_LONG]: {
    titleLocaleKey: 'Video too long.',
    descriptionLocaleKey: 'video_longer_than_limit',
    shortDescriptionLocaleKey: 'exceeds_duration_limit',
  },
  [ERROR_CODES.FILE_METADATA_EXTRACT_FAILED]: {
    titleLocaleKey: 'Failed to process file.',
    descriptionLocaleKey:
      'We were unable to process your file. Please check your file and try again.',
    shortDescriptionLocaleKey: 'Unable to process the file.',
  },
  asset_missing_audio_track: {
    titleLocaleKey: 'No audio detected.',
    descriptionLocaleKey:
      'Please upload a video with clear audio to start editing.',
    shortDescriptionLocaleKey: '',
  },
};
